import { CreateWidget } from "@wac-ui-dashboard/wac_component_library";
import useCreateRoleModal from "./useCreateRoleModal";

const CreateRoleModal = () => {
  const { roleListData, handleRoleClick } = useCreateRoleModal();
  return (
    <div className="pro-m-4">
      <CreateWidget
        description={"Start fresh with a blank role template."}
        icon={<span className="material-symbols-outlined">draft</span>}
        handleClick={handleRoleClick}
      />
      {roleListData?.data?.result?.length !== 0 && (
        <CreateWidget
          description={"Clone settings from previous roles"}
          items={roleListData?.data?.result}
          icon={<span className="material-symbols-outlined">description</span>}
          handleClick={handleRoleClick}
        />
      )}
    </div>
  );
};

export default CreateRoleModal;
